
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const BodyFatDoubleChin = () => {
  const treatments = [
    {
      name: "Kybella",
      href: "/treatments/kybella",
      description: "FDA-approved injectable to dissolve submental fat",
      price: "$699",
      memberPrice: "$499"
    },
    {
      name: "Lipotropic Injections",
      href: "/treatments/lipotropic",
      description: "Fat-burning compounds for metabolism support",
      price: "$149",
      memberPrice: "$99"
    },
    {
      name: "Skin Tightening Laser",
      href: "/treatments/skin-tightening",
      description: "Non-invasive body contouring and firming",
      price: "$550",
      memberPrice: "$399"
    },
    {
      name: "IV Energy Boost",
      href: "/treatments/iv-therapy",
      description: "Metabolism and energy support from within",
      price: "$179",
      memberPrice: "$129"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Body Fat & Double Chin"
      subtitle="No Surgery, No Shame — Just Slimmer Lines"
      description="For stubborn areas (chin, belly, arms), we offer targeted fat dissolvers and contouring support. Perfect for submental fat, stubborn body fat, loose skin, and metabolism support."
      treatments={treatments}
      beforeAfterText="Best results in combo with IV energy boosters and healthy lifestyle support."
    />
  );
};

export default BodyFatDoubleChin;
